import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'kt-conditional-errors-modal',
  templateUrl: './conditional-errors-modal.component.html',
  styleUrls: ['./conditional-errors-modal.component.scss'],
})
export class ConditionalErrorsModalComponent implements OnInit {
  @Input() title: string;
  @Input() msgs: any;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  @Input() isHTML: boolean = false;

  constructor(private activeModal: NgbActiveModal) {}

  ngOnInit() {}

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss(type) {
    this.activeModal.dismiss(type);
  }
}
